module.exports = __webpack_public_path__ + "static/akquinet_logo-c59b0d5ac9ff522a01a9ee31bf33de5d.png";